import { useState } from 'react'
import './purpose.css'
import SubHeading from '../../../subHeading/SubHeading'
import Collapsible from './Collapsible'

import imgUrl from '../../../../assets/img/general/asociacion_img.png'

const principlesSections = [
  {
    title: 'Principios políticos y sociales',
    items: [
      'Feminismo',
      'Justicia ecosocial',
      'Igualdad de género',
      'Equidad',
      'Antirracismo',
      'Decolonialismo',
      'Anticapacitismo',
      'Anticapitalismo',
      'Antineoliberalismo',
      'Laicidad',
      'Accesibilidad',
      'Reconocimiento y respeto de la diversidad de experiencias'
    ]
  },
  {
    title: 'Principios vinculados a nuestra identidad y acción',
    items: [
      'Cultura menstrual crítica',
      'Derechos menstruales',
      'Educación menstrual',
      'Democratización de los cuidados',
      'Compromiso con la erradicación de la pobreza menstrual',
      'Compromiso con la erradicación de las violencias machistas',
      'Pensamiento crítico y reflexión feminista',
      'Transformación de los saberes, prácticas y representaciones en torno a la menstruación y al ciclo vital'
    ]
  },
  {
    title: 'Principios sobre el conocimiento',
    items: [
      'Rigor científico',
      'Contrastación de las fuentes',
      'Reconocimiento de la diversidad de saberes y experiencias',
      'Mirada crítica y contextualizada',
      'No idealización ni romantización de los saberes y experiencias',
      'Reconocimiento de los límites de los conocimientos disponibles'
    ]
  },
  {
    title: 'Valores relacionales y organizativos',
    items: [
      'Transparencia',
      'Cuidado de la salud física, mental y emocional',
      'Respeto a la opinión',
      'Responsabilidad colectiva',
      'Sostenibilidad del proyecto común',
      'Reconocimiento del trabajo, saberes y acciones',
      'Colaboración con compañeras y entidades',
      'Solidaridad internacionalista'
    ]
  }
]

export default function PurposeAlt() {
  const [openIndex, setOpenIndex] = useState(-1)

  return (
    <section className='purpose'>
      <div className='purpose__wrapper-img'>
        <img src={imgUrl} alt='Woman painting a mural' />
      </div>
      <div className='purpose__wrapper-info'>
        <SubHeading title='La Asociación' />
        <div className='purpose__content'>
          <p className='p__main'>La Vida en Rojo es una asociación de cultura menstrual que actúa en los ámbitos político, social, comunitario, institucional y cultural a través de sus ejes: la educación, la divulgación, el activismo, la investigación y la red.</p>
          <p className='p__main'>Promovemos una reflexión crítica feminista que revisa, cuestiona y transforma los saberes, prácticas y representaciones en torno a las experiencias que forman parte del ciclo vital de las mujeres y de las personas con ciclo ovárico y menstrual, desde la menarquia hasta la menopausia.</p>
          <p className='p__main'>Este enfoque democratiza los cuidados, combate la pobreza menstrual y contribuye a erradicar violencias machistas, avanzar en igualdad de género, equidad laboral y reconocimiento de la diversidad de experiencias.</p>

          <div className='purpose__principles'>
            <h3 className='purpose__principles-title'>MARCO DE PRINCIPIOS Y VALORES</h3>
            {principlesSections.map(({ title, items }, index) => (
              <Collapsible
                key={title}
                title={title}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
              >
                <ul className='purpose__principles-list'>
                  {items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </Collapsible>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
